import {
    Injectable,
} from '@angular/core';

@Injectable()
export class IdRegisterService {
    lastId: number = 0;

    generateId(): string {
        this.lastId = Math.floor(Math.random() * 5000) + this.lastId;
        return `${Date.now}-${this.lastId}`;
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/services/id-register.service.ts